import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faTimes } from '@fortawesome/free-solid-svg-icons';

const PWAUpdateNotification = () => {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handleWaiting = (event) => {
      if (event.detail?.registration) {
        setRegistration(event.detail.registration);
      }
    };

    window.addEventListener('budgie:sw-update', handleWaiting);
    return () => window.removeEventListener('budgie:sw-update', handleWaiting);
  }, []);

  const handleUpdate = () => {
    const waiting = registration?.waiting;
    if (!waiting) {
      window.location.reload();
      return;
    }
    waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  const handleDismiss = () => {
    setRegistration(null);
  };

  if (!registration) return null;

  return (
    <div className="pwa-update-banner" role="status" aria-live="polite">
      <div className="pwa-update-copy">
        <FontAwesomeIcon icon={faSync} className="me-2" />
        <span>A new Budgie version is ready.</span>
      </div>
      <div className="pwa-update-actions">
        <Button variant="primary" size="sm" onClick={handleUpdate}>
          Refresh
        </Button>
        <button
          type="button"
          className="app-icon-btn"
          onClick={handleDismiss}
          aria-label="Dismiss update notice"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

export function notifyServiceWorkerUpdate(registration) {
  window.dispatchEvent(
    new CustomEvent('budgie:sw-update', { detail: { registration } })
  );
}

export default PWAUpdateNotification;
